<script lang="ts">
	import { activeQueueTasks } from '@enzianweb/shared';
	import QueueTaskNotification from './QueueTaskNotification.svelte';
</script>

{#if $activeQueueTasks}
	<section class="flex flex-col items-end gap-2 fixed bottom-0 pointer-events-none">
		{#each $activeQueueTasks as queueTask (queueTask.id)}
			<QueueTaskNotification {queueTask}></QueueTaskNotification>
		{/each}
	</section>
{/if}

<style>
	section {
		position: fixed;
		bottom: 30px;
		right: 30px;
		width: 100%;
		margin-top: 1rem;
		z-index: 1000;
	}
</style>
